import React from "react";

const VideoCard = ({ info }) => {
  const { snippet, statistics } = info;
  const { channelTitle, title, thumbnails } = snippet;

  return (
    <div className="p-2 m-2 w-72 h-80 shadow-lg flex flex-col">
      <img
        className="rounded-lg h-40 w-full object-cover" // Ensures thumbnails are of equal height
        alt="thumbnail"
        src={thumbnails.medium.url}
      />
      <ul className="flex-1">
        <li className="font-bold py-2">{title}</li>
        <li>{channelTitle}</li>
        <li>{statistics.viewCount} views</li>
      </ul>
    </div>
  );
};

export const AdVideoCard = ({ info }) => {
  return (
    <div className="p-1 m-1 border border-red-900">
      <VideoCard info={info} />
    </div>
  );
};

export default VideoCard;
